module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/hospital_detail/hyphen-62bb4515aa0bd431e13e4b43f60c04b8.svg";